// aus autolink2.js
// neu Implementierung von enrichment.js -> nummern_linken()
// es geht darum unsere eindeutigen IDs automatisiert zu verlinken

import * as R from 'ramda'
import { MouseEventHandler, ReactNode } from 'react'
import { Link, useLocation } from 'wouter'
import { getLink } from './getLink'

export const LinkRender = (props: {
  value: string
  children?: ReactNode
  onClick?: MouseEventHandler<HTMLAnchorElement>
}) => {
  const [location] = useLocation()
  let link = getLink(props.value)
  const value = R.isEmpty(props.value) ? undefined : props.value

  if (link) {
    // some routing based on location
    if (location?.startsWith('/eap')) {
      link = link.replace('https://huwawi3.hudora.de/wawi/prod/', '/eap/prod/')
      link = link.replace('https://huwawi3.hudora.de/wawi/item/', '/eap/item/')
      link = link.replace('https://huwawi3.hudora.de/wawi/mastersku/', '/eap/mastersku/')
      link = link.replace('https://huwawi3.hudora.de/wawi/sku/', '/eap/sku/')
      link = link.replace('https://huwawi3.hudora.de/ic/mastersku/', '/eap/mastersku/')
      link = link.replace('https://huwawi3.hudora.de/ic/sku/', '/eap/sku/')
    }
    if (location?.startsWith('/stamm')) {
      link = link.replace('/wawi/g/', '/stamm/g/')
      link = link.replace('/wawi/k/', '/stamm/k/')
    }
    if (location?.startsWith('/ic/')) {
      link = link.replace('/einkauf/b', '/ic/po')
    }

    return (
      <Link
        onClick={props.onClick}
        className={link.startsWith('http') ? 'hd-link hd-link-external' : 'hd-link'}
        href={link}
      >
        {props.children || value || '␀'}
      </Link>
    )
  } else {
    return <>{props.children || value || '␀'}</>
  }
}
